import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  BATCH_INVENTORY_RESULTS_REQUESTED,
  BATCH_INVENTORY_RESULTS_SUCCESS,
  BATCH_INVENTORY_RESULTS_FAILURE,
  BATCH_INVENTORY_DOWNLOAD_REQUESTED,
  BATCH_INVENTORY_DOWNLOAD_SUCCESS,
  BATCH_INVENTORY_DOWNLOAD_FAILURE,
  BATCH_INVENTORY_RESULT_ROW_REQUESTED,
  BATCH_INVENTORY_RESULT_ROW_SUCCESS,
  BATCH_INVENTORY_RESULT_ROW_FAILURE,
  LIVE_INVENTORY_SESSIONS_REQUESTED,
  LIVE_INVENTORY_SESSIONS_SUCCESS,
  LIVE_INVENTORY_SESSIONS_FAILURE,
  DOWNLOAD_SAVED_LIVE_SESSION_REQUESTED,
  DOWNLOAD_SAVED_LIVE_SESSION_SUCCESS,
  DOWNLOAD_SAVED_LIVE_SESSION_FAILURE,
} from '../types';

export const batchInventoryResultsRequested = () => {
  return {
    type: BATCH_INVENTORY_RESULTS_REQUESTED
  }
};

export const batchInventoryResultsSuccess = (payload) => {
  return {
    type: BATCH_INVENTORY_RESULTS_SUCCESS,
    payload: payload
  }
};

export const batchInventoryResultsFailure = (error) => {
  console.log(error);
  throw new Error(error);
  
  return {
    type: BATCH_INVENTORY_RESULTS_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
};


export const batchInventoryResulRowRequested = (batchId, actionId) => {
  return {
    type: BATCH_INVENTORY_RESULT_ROW_REQUESTED,
    batchId: batchId,
    actionId: actionId
  }
};

export const batchInventoryResutRowSuccess = (batchId, actionId, payload) => {
  return {
    type: BATCH_INVENTORY_RESULT_ROW_SUCCESS,
    batchId: batchId,
    actionId: actionId,
    payload: payload
  }
};

export const batchInventoryResutRowFailure = (batchId, actionId, error) => {
  console.log(error);
  throw new Error(error);
  
  return {
    type: BATCH_INVENTORY_RESULT_ROW_FAILURE,
    batchId: batchId,
    actionId: actionId,
    status: error.response?.status,
    error: error.response?.data
  }
};

export const batchInventoryDownloadRequested = () => {
  return {
    type: BATCH_INVENTORY_DOWNLOAD_REQUESTED
  }
};

export const batchInventoryDownloadSuccess = (payload) => {
  return {
    type: BATCH_INVENTORY_DOWNLOAD_SUCCESS,
    payload: payload
  }
};

export const batchInventoryDownloadFailure = (batchId, actionId, error) => {
  console.log(error);
  throw new Error(error);

  return {
    type: BATCH_INVENTORY_DOWNLOAD_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
};

export const liveInventorySessionsRequested = () => {
  return {
    type: LIVE_INVENTORY_SESSIONS_REQUESTED
  }
}

export const liveInventorySessionsSuccess = (payload) => {
  return {
    type: LIVE_INVENTORY_SESSIONS_SUCCESS,
    payload: payload
  }
}

export const liveInventorySessionsFailure = (error) => {
  return {
    type: LIVE_INVENTORY_SESSIONS_FAILURE,
    error: error
  }
}

export const liveInventorySessionDownloadRequested = () => {
  return {
    type: DOWNLOAD_SAVED_LIVE_SESSION_REQUESTED
  }
}

export const liveInventorySessionDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_SAVED_LIVE_SESSION_SUCCESS,
    payload: payload
  }
}

export const liveInventorySessionDownloadFailure = (batchId, actionId, error) => {
  console.log(error);
  throw new Error(error);

  return {
    type: DOWNLOAD_SAVED_LIVE_SESSION_FAILURE,
    status: error.response?.status,
    error: error.response?.data
  }
}


export const getBatchResults = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(batchInventoryResultsRequested());

    let endPoint = Config.baseUrl + Config.bulkInventory + Config.allResults;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(batchInventoryResultsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(batchInventoryResultsFailure(error));
      });
  }
}

export const getResultRow = (shopUrl, payload, batchId, actionId) => {
  return (dispatch) => {
    dispatch(batchInventoryResulRowRequested(batchId, actionId));

    let endPoint = Config.baseUrl + Config.bulkInventory + `${batchId}/${actionId}`;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(batchInventoryResutRowSuccess(batchId, actionId, response.data));
      })
      .catch((error) => {
        dispatch(batchInventoryResutRowFailure(batchId, actionId, error));
      });
  }
}

export const downloadBatchResult = (shopUrl, payload, batchId) => {
  return (dispatch) => {
    dispatch(batchInventoryDownloadRequested());

    let endPoint = Config.baseUrl + Config.bulkInventory + Config.batchReport + '&batchId=' + batchId;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(batchInventoryDownloadSuccess(response.data));
      })
      .catch((error) => {
        dispatch(batchInventoryDownloadFailure(error));
      });

  }
}

export const getLiveResults = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(liveInventorySessionsRequested());

    let endPoint = Config.baseUrl + Config.liveSaves;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(liveInventorySessionsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(liveInventorySessionsFailure(error));
      });
  }
}

export const getLiveResult = (shopUrl, payload, csvId) => {
  return (dispatch) => {
    dispatch(liveInventorySessionDownloadRequested());

    let endPoint = Config.baseUrl + Config.liveSave + '/' + csvId;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(liveInventorySessionDownloadSuccess(response.data));
      })
      .catch((error) => {
        dispatch(liveInventorySessionDownloadFailure(error));
      });
  }
}


